export default {
  index: 'leaves-list-view',
  store: 'leaves-create-view',
  edit: 'leaves-edit-view',
  warningNoEmployees: 'leaves-warning-no-employees-view',
};
